(() => {
  if (window.selektContactReady) return;
  window.selektContactReady = true;
  let opener;
  function dialog() { return document.querySelector('[data-sy-contact]'); }
  function showResult() {
    const box = dialog();
    if (box && box.querySelector('[data-sy-form-result]') && !box.open) box.showModal();
  }
  document.addEventListener('click',event => {
    const trigger = event.target.closest('[data-sy-ask]');
    const box = dialog();
    if (trigger && box) {
      event.preventDefault();
      opener = trigger;
      const topic = box.querySelector('[data-sy-topic]');
      if (topic) topic.value = trigger.dataset.syAsk || '';
      const source = box.querySelector('[data-sy-source]');
      if (source) source.value = location.origin + location.pathname + location.hash;
      if (!box.open) box.showModal();
    }
    if(event.target.closest('[data-sy-close]') && box) box.close();
    const play = event.target.closest('[data-koi-play]');
    if (play) {
      const frame = document.createElement('iframe');
      frame.src = play.dataset.koiPlay;
      frame.title = play.dataset.title;
      frame.allow = 'autoplay; fullscreen; picture-in-picture';
      frame.allowFullscreen = true;
      play.replaceWith(frame);
      frame.focus();
    }
  });
  document.addEventListener('close',event => {
    if(event.target.matches('[data-sy-contact]') && opener) opener.focus({preventScroll:true});
  },true);
  showResult();
  document.addEventListener('shopify:section:load',showResult);
})();
